import React from 'react';
import { useTranslation } from 'react-i18next';

const Logo = ({ className = "", size = "normal" }) => {
  const { t } = useTranslation();
  
  const sizeClasses = {
    small: "h-8",
    normal: "h-10",
    large: "h-12"
  };

  const textSizeClasses = {
    small: "text-lg",
    normal: "text-2xl",
    large: "text-3xl"
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Logo Icon - Wood plank with hammer */}
      <div className={`${sizeClasses[size]} flex items-center`}>
        <svg 
          viewBox="0 0 48 48" 
          className={`${sizeClasses[size]} text-wood-brown`}
          fill="currentColor"
        >
          {/* Wood plank background */}
          <rect x="4" y="16" width="40" height="16" rx="2" className="text-wood-light" fill="currentColor" />
          
          {/* Wood grain lines */}
          <line x1="8" y1="20" x2="40" y2="20" stroke="currentColor" strokeWidth="0.5" opacity="0.3" />
          <line x1="8" y1="24" x2="40" y2="24" stroke="currentColor" strokeWidth="0.5" opacity="0.3" />
          <line x1="8" y1="28" x2="40" y2="28" stroke="currentColor" strokeWidth="0.5" opacity="0.3" />
          
          {/* Hammer icon */}
          <g className="text-wood-dark" fill="currentColor">
            {/* Hammer head */}
            <rect x="28" y="8" width="12" height="6" rx="1" />
            {/* Hammer handle */}
            <rect x="18" y="11" width="12" height="2" rx="1" />
            {/* Nail */}
            <circle cx="20" cy="36" r="1" className="text-gray-400" fill="currentColor" />
            <rect x="19.5" y="32" width="1" height="4" className="text-gray-400" fill="currentColor" />
          </g>
          
          {/* Wood texture dots */}
          <circle cx="12" cy="22" r="0.5" opacity="0.2" />
          <circle cx="20" cy="26" r="0.5" opacity="0.2" />
          <circle cx="32" cy="20" r="0.5" opacity="0.2" />
          <circle cx="36" cy="28" r="0.5" opacity="0.2" />
        </svg>
      </div>
      
      {/* Company Name */}
      <div className="flex flex-col">
        <span className={`font-bold ${textSizeClasses[size]} leading-none`}>
          Easy Floor
        </span>
        <span className={`font-semibold text-wood-brown ${size === 'small' ? 'text-sm' : size === 'large' ? 'text-xl' : 'text-lg'} leading-none`}>
          KC
        </span>
      </div>
    </div>
  );
};

export default Logo; 